<script setup>
const user = useStrapiUser()
const sort = defineModel('sort', { type: String, default: '' })

const isProfessional = computed(() => user.value?.type === 'professional')
</script>

<template>
  <div v-if="isProfessional" class="flex items-center justify-end">
    <div class="select-wrapper relative mb-6 w-full lg:w-auto">
      <select
        v-model="sort"
        class="min-w-52 block h-12 w-full appearance-none rounded-lg border-b-2 border-gray-300 bg-white py-3 pl-3 pr-10 text-base text-gray-800 focus:outline-none"
      >
        <option value="" disabled selected>Sorteer op</option>
        <option value="match:ASC">Match oplopend</option>
        <option selected value="match:DESC">Match aflopend</option>
        <option value="personality:ASC">Persoonlijkheid oplopend</option>
        <option value="personality:DESC">Persoonlijkheid aflopend</option>
        <option value="cognitive:ASC">Cognitief oplopend</option>
        <option value="cognitive:DESC">Cognitief aflopend</option>
        <option value="motivations:ASC">Drijfveren oplopend</option>
        <option value="motivations:DESC">Drijfveren aflopend</option>
      </select>
      <div
        class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-2"
      >
        <IconSelect class="h-3 w-3 text-gray-800" />
      </div>
    </div>
  </div>
</template>
